<!-- <ng-container *ngIf="unavailableProducts$ | async  as unavailableProducts"> -->
@if (unavailableProducts?.products; as products) {
  @if (products.length > 0) {
    <div>
      <div class="unavailable-products-container">
        <div class="title">
          {{ 'cartDetails.unavailableProductsTitle' | cxTranslate }}
        </div>
        @for (product of products; track product; let i = $index) {
          <div
            class="unavailable-products-entry {{i == 0 ? 'first-entry' : ''}}">
            <div class="product-info">
              <div class="col-2 cx-image-container">
                <div class="image">
                  @for (productImage of product.images; track productImage; let i = $index) {
                    @if ((productImage.format).includes('product')) {
                      <a [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" cxModal="dismiss" tabindex="-1">
                        <cx-media [container]="productImage" format="product"></cx-media>
                      </a>
                    }
                  }
                </div>
              </div>
              <div class="cx-info col-10">
                <div class="manufacturer">{{product.manufacturer}}</div>
                <div class="name">
                  <a class="cx-link" [routerLink]="{ cxRoute: 'product', params: product } | cxUrl" cxModal="dismiss">
                    {{product.name}}
                  </a>
                </div>
              </div>
            </div>
            <div class="product-availability">
              @if (product.stock.visible) {
                <div class="notify">
                  <app-custom-stock-notification [product]="product"></app-custom-stock-notification>
                  <span>{{ 'cartDetails.unavailableProductsNotify' | cxTranslate }}</span>
                </div>
                @if (isLogged | async; as logged) {
                  <div class="wishlist">
                    <app-custom-add-to-wish-list [product]="product"></app-custom-add-to-wish-list>
                    <span>{{ 'cartDetails.unavailableProductsWishlist' | cxTranslate }}</span>
                  </div>
                }
              }
              @if (!product.stock.visible) {
                <div class="not-visible-content">
                  <div class="icon-content">
                    <app-custom-icons [type]="iconTypes.SAD_FACE"></app-custom-icons>
                  </div>
                  <div class="not-visible">
                    {{ 'cartDetails.unavailableProductsNotVisible' | cxTranslate }}
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }
}
<!-- </ng-container> -->